"use strict";
$(document).foundation();
(function ($, window) {
    var BVCTable = function (a) {};
    BVCTable.prototype = {
        initialize: function () {
            $(".bvcTableClick-row").click(function () {
                window.location = $(this).data("href");
            });
        }
    };
    window.BVCTable = new BVCTable();
    window.BVCTable.initialize();
})(jQuery, this, this.document, undefined);